/*
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 *
 */

import config from '@/config';
import { FEATURE_CAMPAIGNS } from '@/constants/features.js';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.campaigns.home],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CAMPAIGNS),
            getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['view'] }])
        ]),
        controller: () => import('./controllers/campaigns')
    },
    {
        path: [config.routes.campaigns.create],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CAMPAIGNS),
            getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['create'] }])
        ]),
        controller: () => import('./controllers/campaign.create.edit')
    },
    {
        path: [config.routes.campaigns.edit],
        guard: multiGuard([
            getFeaturesGuard(FEATURE_CAMPAIGNS),
            getPermissionsGuard([{ resource: 'portal.campaign', scopes: ['edit'] }])
        ]),
        controller: () => import('./controllers/campaign.create.edit')
    }
];
